import { configuracaoStore } from '@/infrastructure/store/configuracaoStore';

import { hojeNaFabrica } from './fuso';

/**
 * Today, as the FACTORY counts it: `YYYY-MM-DD` in the zone saved in Configurações ›
 * Jornada. ONE source for every screen that asks "is this today?".
 *
 * The browser clock is the reader's, not the factory's. Three screens used to derive the
 * day from it (and one from UTC), so after 21:00 in São Paulo the queue history, the
 * launched list and the portfolio summary each believed a different day had started, and
 * an event from last night showed up as today's.
 *
 * Reads the store OUTSIDE React on purpose, like `readLastErrorCode` does: the day is
 * needed by plain helpers and table configs, not only by components, and threading the
 * zone through every one of them would put a parameter nobody chooses on each signature.
 * Config still loading falls back to the same seed the server falls back to.
 */
export function hojeNaFabricaISO(): string {
  return hojeNaFabrica(configuracaoStore.getState().config?.jornada);
}
